"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseTask_1 = __importDefault(require("./BaseTask"));
/**
 * [[RunnableTask]] Task wrapper for any Promised-operation
 */
class RunnableTask extends BaseTask_1.default {
    constructor(logger, fn, taskName = 'RunnableTask') {
        super(logger);
        this.fn = fn;
        this.taskName = taskName;
    }
    run() {
        return this.fn().then(() => { });
    }
}
exports.default = RunnableTask;
//# sourceMappingURL=RunnableTask.js.map